// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d6b98941","455":"f9af2113","644":"f6489c48"}[chunkId] + ".chunk.js";
};